export default __webpack_public_path__ + "static/media/fabrik.ca79e586.png";